export default __webpack_public_path__ + "static/media/intro-line-light.6d0ca977.webp";